module.exports = __webpack_public_path__ + "media/images/games/35reveal/girl-3c8088bb36ce79adba93c51f5c03b885.png";